import { LoaderFunction, LoaderFunctionArgs, redirect } from "react-router-dom";
import TokenService from "services/token.service";

// withAuth is a higher order function that redirects back to the login path if not authenticated
// This approach is taken from this discussion: https://github.com/remix-run/react-router/discussions/12510
// This is a lightweight version of middleware which ReactRouter is heading towards in the latest version:
// https://reactrouter.com/how-to/middleware
export function withAuth(loader: LoaderFunction) {
  return async (args: LoaderFunctionArgs) => {
    if (!Boolean(TokenService.get("accessToken"))) return redirect("/login");
    return loader(args);
  };
}
